<div class="activity-item"
     [style]="{'border-color': notification().ColorAccent }">
  <div class="activity-item-header">
    <div class="activity-item-icon"
         [style]="{'background': notification().ColorPrimary }">{{ notification().Icon }}
    </div>
    <div>
            <span class="activity-item-title"
                  [style]="{'color': notification().ColorPrimary }">{{ notification().Eyebrow }}
            </span>
      <div class="activity-item-eyebrow"
           [style]="{'color': notification().ColorAccent }">
        {{ notification().Title }}
      </div>

      <div class="activity-item-desc">{{ notification().Body }}</div>

      @if (notification().CtaUrl) {
        <div class="activity-item-actions">
          <a class="small-btn"
             [href]="notification().CtaUrl"
             [style]="{'background-color': notification().ColorPrimary }">{{ notification().CtaLabel }}
          </a>
        </div>
      }
    </div>
  </div>
</div>
